module.exports = __webpack_public_path__ + "assets/img/1.c91d70fd.png";